import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Button, Text } from 'primitive-components';
import { colors } from 'bench-style-constants';
import { Modal } from 'modal-components';

const Layout = styled.div`
  display: grid;
  grid-row-gap: 16px;
`;

const Overlay = styled.div`
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
`;

const PrimaryButton = styled(Button)`
  color: ${colors.copper};
  &:hover {
    color: ${colors.pipe};
  }
  &:disabled {
    color: ${colors.smoke};
  }
`;
const SecondaryButton = styled(Button)``;

const clientProceeded = clientId => {
  if (window.analytics && window.analytics.track) {
    window.analytics.track('Client proceeded with sending possible credit card info from CWA', {
      clientID: clientId,
      clientAction: 'proceeded',
    });
  }
};

const clientCancelled = clientId => {
  if (window.analytics && window.analytics.track) {
    window.analytics.track('Client cancelled sending possible credit card info from CWA', {
      clientID: clientId,
      clientAction: 'cancelled',
    });
  }
};

const CCModal = ({ onClose, onSend, clientId }) => (
  <Overlay onClick={event => event.currentTarget === event.target && onClose()}>
    <Modal size="large">
      <Modal.Header title="Uh-Oh!" onClose={onClose} />
      <Modal.Body>
        <Layout>
          <Text>
            This message appears to contain vulnerable personal information. Sending private details
            like credit card information and passwords through message feeds makes you more
            vulnerable to identity theft, should your Bench login be compromised.
          </Text>
          <Text>
            To edit your message before sending, please select <strong>“Cancel”</strong>. If you
            have received this message by mistake, please select <strong>“Proceed”</strong> to
            continue sending your message. Thank you for your cooperation and understanding.
          </Text>
          <PrimaryButton
            onClick={() => {
              onSend();
              onClose();
              clientProceeded(clientId);
            }}
          >
            Proceed
          </PrimaryButton>
          <SecondaryButton
            onClick={event =>
              event.currentTarget === event.target && (onClose(), clientCancelled(clientId))
            }
          >
            Cancel
          </SecondaryButton>
        </Layout>
      </Modal.Body>
    </Modal>
    ){'}'}
  </Overlay>
);

CCModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
};

export default CCModal;
